import classNames from "classnames";
import styles from "./Video.module.scss";

type Props = {
    playing: boolean;
    onClick: () => void;
};

export const PlayButton = ({playing, onClick}: Props) => (
    <div
        className={classNames(styles.playButton, {
            [styles.play]: !playing,
            [styles.pause]: playing,
        })}
        onClick={onClick}
    />
);
